export default __webpack_public_path__ + "static/media/7.6a1fe944.svg";